import api from "./Api";
import readWithRetry from "./readWithRetry";

export const listarAlarmasProgramadas = async (archivadas = false, signal) => (await readWithRetry("/ConfiguracionAlarmas", { params: { archivadas }, signal })).data;
export const archivarAlarma = async (id) => (await api.post(`/ConfiguracionAlarmas/${id}/archivar`)).data;
export const recuperarAlarma = async (id) => (await api.post(`/ConfiguracionAlarmas/${id}/recuperar`)).data;
export const crearAlarmaProgramada = async (payload) => (await api.post("/ConfiguracionAlarmas", payload)).data;
export const actualizarAlarmaProgramada = async (id, payload) => (await api.put(`/ConfiguracionAlarmas/${id}`, payload)).data;
export const cambiarEstadoAlarma = async (id, estaActivo) => (await api.patch(`/ConfiguracionAlarmas/${id}/estado`, { estaActivo })).data;
export const silenciarAlarma = async (id, minutos) => (await api.post(`/ConfiguracionAlarmas/${id}/silenciar`, { minutos })).data;
export const desactivarAlarma = async (id) => (await api.delete(`/ConfiguracionAlarmas/${id}`)).data;
export const listarHistorialAlarmas = async (signal) => (await readWithRetry("/Alarmas", { params: { limite: 300 }, signal })).data;
export const reconocerEventoAlarma = async (id) => (await api.post(`/Alarmas/${id}/reconocer`, {})).data;

const alarmaService = {
  listarAlarmasProgramadas, archivarAlarma, recuperarAlarma, crearAlarmaProgramada, actualizarAlarmaProgramada,
  cambiarEstadoAlarma, silenciarAlarma, desactivarAlarma,
  listarHistorialAlarmas, reconocerEventoAlarma,
};

export default alarmaService;
